import {invert} from 'lodash';

/*
 * Functions to obfuscate and deobfuscate a string in O(n) time.
 *
 * The r29-initial-state element contains a JSON string representating all
 * of the state of our application, including some URLs.
 *
 * Google's crawler is crafty, and often tries to visit these URLs even if
 * they don't show up in any of the actual markup.
 *
 * Therefore, let's just use a very simple cipher to "encode" this
 * string.
 *
 * (Another option would be to encode using base64, but that unnecessarily
 * increases the length of the JSON string)
 */

const FIRST_CHAR_CODE = 65; // A
const LAST_CHAR_CODE = 122; // z
const RANGE = LAST_CHAR_CODE - FIRST_CHAR_CODE + 1;
const SHIFT = 29;
// Extra obfuscation for things outside the alphabet
const CUSTOM_MAPPING_OBFUSCATE = {
  '{': ':',
  ':': '/',
  '/': '}',
  '}': '<',
  '<': '"',
  '"': '>',
  '>': '{'
};
const CUSTOM_MAPPING_DEOBFUSCATE = invert(CUSTOM_MAPPING_OBFUSCATE);

export const obfuscate = s => {
  return Array.from(s).map(char => {
    if (CUSTOM_MAPPING_OBFUSCATE[char]) {
      return CUSTOM_MAPPING_OBFUSCATE[char];
    }

    const charCode = char.charCodeAt(0);

    if (!isInAlphabet(charCode)) {
      return char;
    }

    const charCodeMappedToZero = charCode - FIRST_CHAR_CODE;
    return String.fromCharCode(
      (charCodeMappedToZero + SHIFT) % RANGE + FIRST_CHAR_CODE
    );
  }).join('');
};

export const deobfuscate = s => {
  return Array.from(s).map(char => {
    if (CUSTOM_MAPPING_DEOBFUSCATE[char]) {
      return CUSTOM_MAPPING_DEOBFUSCATE[char];
    }

    const charCode = char.charCodeAt(0);

    if (!isInAlphabet(charCode)) {
      return char;
    }

    const unshifted = charCode - SHIFT;
    return unshifted >= FIRST_CHAR_CODE
      ? String.fromCharCode(unshifted)
      : String.fromCharCode(
        LAST_CHAR_CODE + 1 - (FIRST_CHAR_CODE - unshifted)
      );
  }).join('');
};

function isInAlphabet(charCode) {
  return charCode >= FIRST_CHAR_CODE && charCode <= LAST_CHAR_CODE;
}
